// extracted by mini-css-extract-plugin
export default {"wrapper":"HiviewerLoader_wrapper__GsJi8","logo":"HiviewerLoader_logo__xmsX6","letter":"HiviewerLoader_letter__8C62S"};